import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { Music2, Disc3 } from 'lucide-react';

const Upload = () => {
  const navigate = useNavigate();

  const handleTypeSelect = (type: 'single' | 'album') => {
    navigate(`/dashboard/upload/${type}`);
  };

  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Upload New Release</h1>
          <p className="text-gray-300">Choose your release type to get started.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Single Track Option */}
          <button
            onClick={() => handleTypeSelect('single')}
            className="bg-gray-900/80 backdrop-blur-xl rounded-xl border border-purple-500/20 p-8 hover:border-purple-500/40 transition-all transform hover:scale-105 text-left group"
          >
            <div className="bg-purple-500/20 p-4 rounded-lg w-fit mb-4 group-hover:bg-purple-500/30 transition-colors">
              <Music2 className="h-8 w-8 text-purple-400" />
            </div>
            <h2 className="text-2xl font-bold mb-2 text-white">Single Track</h2>
            <p className="text-gray-300 mb-4">
              Upload a single song for release. Perfect for singles and standalone tracks.
            </p>
            <ul className="space-y-2 text-sm text-gray-300">
              <li className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full bg-purple-400"></div>
                One audio track
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full bg-purple-400"></div>
                Cover artwork
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full bg-purple-400"></div>
                Basic metadata
              </li>
            </ul>
          </button>

          {/* EP/Album Option */}
          <button
            onClick={() => handleTypeSelect('album')}
            className="bg-gray-900/80 backdrop-blur-xl rounded-xl border border-purple-500/20 p-8 hover:border-purple-500/40 transition-all transform hover:scale-105 text-left group"
          >
            <div className="bg-purple-500/20 p-4 rounded-lg w-fit mb-4 group-hover:bg-purple-500/30 transition-colors">
              <Disc3 className="h-8 w-8 text-purple-400" />
            </div>
            <h2 className="text-2xl font-bold mb-2 text-white">EP/Album</h2>
            <p className="text-gray-300 mb-4">
              Upload multiple tracks as a complete EP or album release.
            </p>
            <ul className="space-y-2 text-sm text-gray-300">
              <li className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full bg-purple-400"></div>
                Multiple audio tracks
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full bg-purple-400"></div>
                Album artwork
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full bg-purple-400"></div>
                Track ordering
              </li>
            </ul>
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Upload;